import { Chip, Select } from "@ui";
import style from "./TariffCell.module.scss";
import { useGetAdminTariffsQuery } from "@RTKQuery/admin/tariffs/tariffs";
import { IProxy } from "@interfaces/admin/proxy";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { addRowError, removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { IoClose } from "react-icons/io5";
import cn from "classnames";
import { ITariff } from "@interfaces/admin/tariff";

export function TariffCell({ currentTariff, proxy }: { currentTariff: IProxy["tariff"], proxy: IProxy | IProxy["children"][0] }) {
    const { data: tariffsData } = useGetAdminTariffsQuery();

    const [updateProxyData, { isSuccess, reset }] = useUpdateProxyDataMutation();

    const {activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling} = useAppSelector(state => state.myProxiesAdminPage);
    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy.id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: proxy.id, 
                colName: "tariff_id"
            }))
        }
    }, [isSuccess])

    return (
        <div className={style.cell}>
            <Select
                currentValue={currentTariff ? {
                    label: currentTariff.name,
                    value: String(currentTariff.id)
                } : {
                    label: "Не вибрано",
                    value: "-1"
                }}
                listValues={tariffsData?.map(item => ({
                    label: item.name,
                    value: String(item.id)
                })) || []}
                onChange={(value) => {
                    updateProxyData({
                        proxy_id: proxy.id,
                        parent_id: proxy.parent_id || undefined,
                        params: {
                            page: activePaginationPage,
                            limit: activePaginationLimit,
                            router_id: activeSearchIdParameter,
                            operator: activeOperator,
                            phone_number: activeSearchPhoneParameter,
                            selling: activeSelling
                        },
                        body: {
                            tariff: {
                                id: Number(value.value),
                                name: value.label as ITariff["name"]
                            }
                        }
                    })
                }}
            />

            <div className={cn("absolute left-full top-1/2 z-10 pl-[5px] -translate-y-1/2", rowsIsError.includes("tariff_id") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: proxy.id, 
                                colName: "tariff_id"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}